<template>
	<v-dialog
      v-model="dialogContrOk"
      max-width="800px"
      persistent>
      <v-card id="popStyle03">
        <!--팝업 제목-->
        <v-card-title class="title">
          계약요청
          <v-btn fab class="popBtnClose" @click="dialogContrOk = false"></v-btn>
        </v-card-title>
        <!--/팝업 제목-->
        <!--팝업 내용-->
        <v-card-text>
          <v-row no-gutters class="justify-center popCon">
            <div class="dot_tt16 mb-2">계약 진행 상태</div>
            <v-col cols="12" class="next2step_end_logBox row_mb-40">
              <v-card-text class="box_log">
                <ul>
                  <li>
                    <div class="box_log_icon">
                      <!--계약로그 상태 icon-->
                      <!--class=
                        (고정)log_icon
                        (상태에 따라) 
                        저장 = type01_01 / 거부 = type01_02 / 완료  = type01_03
                        전송 = type02_00 / 검토요청 = type02_01 
                        서명(내서명) = type03_01 / 서명(남서명) = type03_02 / 
                      -->
                      <span class="log_icon type01_01"></span>
                      <!--계약로그 상태-->
                      <span class="txt_ing">저장</span>
                    </div>
                    <div class="box_log_txt">[{{ tmpUploadPrc.ctrPaperUpInfo.oriFileName }}] 를 저장하였습니다.</div>
                  </li>
                  <li v-for="(item, index) in ctrTblList" :key="index">
										<div v-if="personalBrokerPrcFlag === 'PERSONAL'">
											<div class="box_log_icon">
												<span class="log_icon type02_00"></span>
												<!--계약로그 상태-->
												<span class="txt_ing">계약요청</span>
											</div>
											<div class="box_log_txt"  v-if="
															((item.receiverEmail !== undefined && item.receiverEmail !== '') &&
															(item.receiverOrganizationRegistrationNumber === undefined || item.receiverOrganizationRegistrationNumber === ''))">
												[{{ tmpUploadPrc.ctrPaperUpInfo.oriFileName }}] 를 [수신자] {{ item.receiverEmail }} 에게 계약요청 합니다.
											</div>
											<div class="box_log_txt"  v-else-if="
															((item.receiverEmail !== undefined && item.receiverEmail !== '') &&
															(item.receiverOrganizationRegistrationNumber !== undefined && item.receiverOrganizationRegistrationNumber !== ''))">
															[{{ tmpUploadPrc.ctrPaperUpInfo.oriFileName }}] 를 [수신자] {{ item.receiverEmail }} [대행자] {{ item.receiverBrokerName }} 에게 계약요청 합니다.
											</div>
										</div>
										<div v-if="personalBrokerPrcFlag === 'BROKER'">
												<div class="box_log_icon">
												<span class="log_icon type02_00"></span>
												<!--계약로그 상태-->
												<span class="txt_ing">계약요청</span>
											</div>
											<div class="box_log_txt" v-if="
                            ((item.receiverEmail !== undefined && item.receiverEmail !== '') &&
                            (item.receiverOrganizationRegistrationNumber === undefined || item.receiverOrganizationRegistrationNumber === ''))">
												[{{ tmpUploadPrc.ctrPaperUpInfo.oriFileName }}] 를 [수신자] {{ item.receiverEmail }} 에게 계약요청 합니다.
											</div>
											<div class="box_log_txt"  v-else-if="
                            ((item.receiverEmail !== undefined && item.receiverEmail !== '') &&
                            (item.receiverOrganizationRegistrationNumber !== undefined && item.receiverOrganizationRegistrationNumber !== ''))">
															[{{ tmpUploadPrc.ctrPaperUpInfo.oriFileName }}] 를 [수신자] {{ item.receiverEmail }} [대행자] {{ item.receiverBrokerName }} 에게 계약요청 합니다.
											</div>
										</div>
                  </li>
                </ul>
              </v-card-text>
            </v-col>
            <v-col cols="12" class="popaddMark_btnCon">
              <div class="dot_tt16 mb-2"> <!--워터마크 : {{ $store.state.app.watermarkAttach?'첨부':'미첨부'}}-->
                <v-btn outlined class="btn17_00 btn_pAright" @click="openWmDialog()">서명/워터마크 첨부</v-btn>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <!--/팝업 내용-->
        <!--팝업 버튼-->
        <v-card-actions class="justify-center">
          <v-btn text @click="popCtrBlockChainPwLayer()">확인</v-btn>
          <v-btn text @click="dialogContrOk = false">취소</v-btn>
        </v-card-actions>
        <!--/팝업 버튼-->
      </v-card>
			<insert-watermark
          :groupId="-1"
          :contractNum="ctrGlobalFrm.ctrNo"
          :pdfFileName="tmpUploadPrc.ctrPaperUpInfo.uploadPDFFileName"
          contractStatus="CR"
          :signal="personalBrokerPrcFlag"
          :key="componentKey"
          ref="insertWatermark"
					 @child="fnWmAttach">
      </insert-watermark>
			<pubCert ref="pubCert" :cert-regno="purCertInfo.certRegNo" :hash="purCertInfo.hash"  @childs-event="purCertResult"></pubCert>
      <s-confirm ref="confirm"></s-confirm>
  	  <s-loading ref="loading"></s-loading>
    </v-dialog>
</template>
<script>
import insertWatermark from '@/views/contract/addNew/components/insertWatermark'
import pubCert from '@/components/pubCert'
import {
	getCtrFileHash,
	convFrmDataToReqJsonParam,
	validateConvWmPDFPath,
	defaultConstValue
} from '@/api/contract/addNew'

const KEY_NAMES_OBJ = defaultConstValue()

export default {
  name: 'popContrOk',
  components: {
		insertWatermark,
		pubCert
  },
  props: {
    parentData: {}
  },
  filters: {
  },
  data () {
    return {
			keyNames: KEY_NAMES_OBJ,
      insertWatermark: false,
      //  다이얼로그
      dialogContrOk: false,
      // 컴포넌트 강제 리렌더링을 위한 변수 (component의 key 값을 변경함으로써 기존 component가 자신을 다시 초기화하고 재설정한다.)
      componentKey: 0,
      wmAttach: false,
      hashFileName: '',
      hashValue: '',
			certPEM: '',
			CtrWaterMarkKey: 0,
			purCertInfo:{
        certRegNo:'',
        hash: ''
			},
			tmpUploadPrc: {
        ctrPaperUpInfo: {},
        ctrPaperAttachInfo: []
			},
			ctrGlobalFrm: {
        ctrNo: '',
        ownerAddress: '',
        ownerName: '',
        senderAddress: '',
        senderName: '',
        senderBrokerAddress: '',
        senderBrokerName: '',
        receiverAddress: '',
        receiverName: '',
        receiverBrokerAddress: '',
        receiverBrokerName: '',
        receiverBrokerChkYN: false,
        receiverEmail: '',
        receiverPhone: '',
        receiverOrgNum: '',
        receiverKey: '',
        ctrLockType: '',
        ctrSignType: '',
        ctrEmailMessage: ''
			},
			ctrTblList: [],
			personalBrokerPrcFlag: 'PERSONAL',
			pdfConvPrc: {
        convPdfReqId: '',
        isPDFConvFail: false,
        isFinishConvPDF: false,
        isConvPDFPathOK: false,
        isConvPDFPathOKToMakeThumb: false,
        recursiveCallChkPDFPathLimit: 0,
        recursiveCallThresholdCnt: 10, // PDF 썸네일 만들기 위해 callback 지연에 대한 검사 제한 횟수
        isExecWmPrc: false, // 워터마크 프로세스 실행 여부
        convertedPDFThumbNail: '',
        defaultThumbNailView: 'https://png.icons8.com/color/240/000000/pdf-2.png',
        viewPdfThumbUrl: ''
			},
			certResultData: {
        certPEM: '',
        certSign: ''
      },
			fileHashName: '',
    }
  },
  created () {
  },
  mounted () {
		
  },
  methods: {
    open(reqParam, ctrTypeFlag) {
			this.reqParamJson = reqParam
			var tmpUploadPrc = 'tmpUploadPrc'
			var ctrPaperUpInfo = 'ctrPaperUpInfo'
			var ctrGlobalFrm = 'ctrGlobalFrm'
			var ctrTblList = 'ctrTblList'
			if (this.reqParamJson[tmpUploadPrc] !== undefined ) {
				this.tmpUploadPrc.ctrPaperUpInfo = this.reqParamJson[tmpUploadPrc][ctrPaperUpInfo]
				this.ctrGlobalFrm = this.reqParamJson[ctrGlobalFrm]
				this.ctrTblList = this.reqParamJson[ctrTblList]
      }
      this.purCertInfo.certRegNo = this.ctrGlobalFrm.organizationRegistrationNumber
      
			// 개인, 계약대행 계약 선택여부 상태 설정
			this.personalBrokerPrcFlag = ctrTypeFlag
			// var tmpUploadPrc = 'tmpUploadPrc'
			// var ctrGlobalFrm = 'ctrGlobalFrm'
			// this.tmpUploadPrc = this.reqParamJson[tmpUploadPrc]
			// this.ctrGlobalFrm = this.reqParamJson[ctrGlobalFrm]
      this.dialogContrOk = true
		},
    openWmDialog () {
      this.$refs.insertWatermark.open()
    },
    fnWmAttach : function (message) {
      this.wmAttach = message
		},
		close() {
			this.dialogContrOk = false
		},
		popCtrBlockChainPwLayer () {
      // 워터마크 프로세스를 탔다면 워터마크 파일이 생성됐는지 검사한다.
      // 뒷단에서 DB, 스토리지에 저장시 uploadWmPDFFileName를 가져와서
      // uploadPDFFileName에 overwrite시켜 저장시킴
      
      this.pdfConvPrc.isExecWmPrc = this.$store.state.app.watermarkAttach

      if (this.pdfConvPrc.isExecWmPrc) {
        // 워터마크 처리되면서 새로 생성될 PDF 파일명을 지정
        // 뒷단에서 이 필드의 값이 있을 경우 uploadPDFFileName을 overwrite해서 DB와 스토리지에 저장하며
        // 이 필드의 값이 없을경우엔 워터마크 프로세스 수행전의 uploadPDFFileName(1차 변환된 PDF)를
        // 저장하게 된다.
        var convPDFFileName = this.$store.state.app.convertPdfName
        if (convPDFFileName !== undefined && convPDFFileName != null && convPDFFileName !== '' & convPDFFileName !== 'empty') {
          this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadWmPDFFileName] =
            convPDFFileName.substring(0, convPDFFileName.lastIndexOf('.')) + '.pdf'
          this.fileHashName = convPDFFileName
        } else {
          this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadWmPDFFileName] = this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName]
          this.fileHashName = this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName]
        }
        getCtrFileHash({ fileHashName: this.fileHashName }).then(response => {
          if (response.rdata.rcode === 20000) {
            this.purCertInfo.hash = response.rdata.hashValue
          }
        }).catch(e => {
        })

        validateConvWmPDFPath(convFrmDataToReqJsonParam(this.reqParamJson)).then(response => {
          
          if (response.rcode === 20000) {
            
            if (response.rdata.isConvPDFPathOK) {
              // 블록체인 암호 설정 레이어 팝업 오픈
              // 계약 서명이 인증 서명일 경우 인증 오픈, 아닐경우 바로 블록체인 암호 설정 레이어 팝업 오픈
              if (this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrSignType === 1) {
                this.$refs.pubCert.open()
              } else {
                this.reqDialog = this.reqDialog + 1
								// this.layerPop.ctrBlckChainPwLayerVisible = true
								this.dialogContrOk = false
								this.$emit('ctrevent', this.certResultData)
              }
            } else {
							this.$refs.confirm.open('alert', '워터마크', '워터마크 처리후 서버의 응답을 기다리는 중입니다. 다시 시도해주세요.')
            }
          } else {
						this.$refs.confirm.open('alert', '워터마크', '워터마크 처리후 서버의 응답을 기다리는 중입니다. 다시 시도해주세요.')
          }
        }).catch(() => {
					this.$refs.confirm.open('alert', '워터마크', '워터마크 처리 완료여부 검사중 시스템 오류가 발생했습니다.')
        })
      } else {
        // 워터마크 프로세스를 타지 않았다면 검사 없이 넘어감
        // 뒷단에서 DB, 스토리지에 저장시 uploadPDFFileName이 저장된다.
        // 블록체인 암호 설정 레이어 팝업 오픈
        // 계약 서명이 인증서 서명일 경우 인증서 오픈, 아닐경우 바로 블록체인 암호 설정 레이어 팝업 오픈
        if (this.reqParamJson[this.keyNames.frmName.ctrGlobalFrm].ctrSignType === 1) {
          this.fileHashName = this.tmpUploadPrc.ctrPaperUpInfo[this.keyNames.ctrPaperUpInfoKeys.uploadPDFFileName]

          getCtrFileHash({ fileHashName: this.fileHashName }).then(response => {
            if (response.rdata.rcode === 20000) {
              this.purCertInfo.hash = response.rdata.hashValue
            }
          }).catch(e => {
          })
          
          this.$refs.pubCert.open()
        } else {
          this.$emit('ctrevent', this.certResultData)
          this.reqDialog = this.reqDialog + 1
					// this.layerPop.ctrBlckChainPwLayerVisible = true
					this.dialogContrOk = false
        }
      }
		},
		purCertResult (vid, errorMessage, pem, sign) {
      this.errorMessage = errorMessage
      if (vid) {
        this.dialogContrOk = false
        this.certResultData.certSign = sign
        this.certResultData.certPEM = pem
        this.reqDialog = this.reqDialog + 1
        this.$emit('ctrevent', this.certResultData)
      } else {
        this.$refs.confirm.open('alert', '공동인증', '인증에 실패하였습니다.')
      }
    },
  }
}
</script>
<style scoped>
</style>